import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/cookies/page.tsx");
